import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ImageModule } from '@df/module-image/image.module';
import { RatioOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
interface IPageComponentImageQuoteItemData {
    variant: 'image' | 'quote';
    image?: string;
    ratio?: string;
    quote?: string;
    quote_font_style: string;
    caption?: string;
    caption_align?: 'left' | 'right';
}
export interface PageComponentImageQuoteComponentData extends NICmsContentComponent.IData {
    columns: IPageComponentImageQuoteItemData[];
}
@Component({
    selector: 'page-component-image-quote',
    templateUrl: './image-quote.html',
    standalone: true,
    imports: [RouterLink, NgClass, ImageModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentImageQuoteComponent>({
    id: 'image-quote',
    name: 'Image and Quote',
    description: '50/50 Image Quote',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'columns',
            title: 'Columns',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Column',
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'variant',
                    title: 'Variant',
                    default: 'image',
                    options: [
                        {
                            key: 'image',
                            title: 'Image'
                        },
                        {
                            key: 'quote',
                            title: 'Quote'
                        }
                    ]
                },
                {
                    key: 'image',
                    title: 'Image Upload',
                    type: NICmsContentField.EFieldType.image,
                    canShow: data => data.variant === 'image'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'ratio',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Ratio',
                    options: RatioOptions,
                    default: 'ratio-1-1',
                    canShow: data => data.variant === 'image'
                },
                {
                    key: 'url',
                    title: 'Link',
                    type: NICmsContentField.EFieldType.text,
                    canShow: data => data.variant === 'image'
                },
                {
                    key: 'quote',
                    title: 'Quote',
                    type: NICmsContentField.EFieldType.text,
                    canShow: data => data.variant === 'quote'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'quote_font_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Quote Font Style',
                    options: TextStyleOptions,
                    default: 'p1',
                    canShow: data => data.variant === 'quote'
                },
                {
                    key: 'caption',
                    title: 'Caption',
                    type: NICmsContentField.EFieldType.text
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'caption_align',
                    title: 'Caption alignment',
                    default: 'left',
                    options: [
                        {
                            key: 'left',
                            title: 'Left'
                        },
                        {
                            key: 'right',
                            title: 'Right'
                        }
                    ],
                    canShow: data => data.variant === 'image'
                }
            ],
            maxSize: 2,
            default: [
                {
                    variant: 'image',
                    ratio: 'ratio-1-1',
                    caption: 'Caption',
                    caption_align: 'left',
                    image: '/cms/media/default.svg'
                },
                {
                    variant: 'quote',
                    quote_font_style: 'h5',
                    quote: 'Quote',
                    caption: 'Caption'
                }
            ]
        }
    ]
})
export class PageComponentImageQuoteComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component: PageComponentImageQuoteComponentData;
}
